import React, { FC } from 'react'
import { Button } from '@/atoms/Button'
import { CircleCloseIcon } from '@/atoms/Icons/CircleCloseIcon'
import { Image } from '@/atoms/Image'
import { ParagraphMD, ParagraphSM } from '@/atoms/Text'
import { Modal } from '@/molecules/Modal'
import { GTitleLG, GTitleMD } from '@/views/PreSales/PreSalesGiveawayView/components/UI/Typography'

interface Props {
  isModalOpen: boolean
  handleCloseModal: () => void
}

export const EmailModal: FC<Props> = ({ isModalOpen, handleCloseModal }) => {
  return (
    <Modal
      isOpen={isModalOpen}
      onClose={handleCloseModal}
      panelClasses="md:max-w-md max-w-[calc(100vw-4em)] !bg-[#040A13] py-16 px-12 md:!p-16 text-center border-4 border-[#DA2031]"
    >
      <div className="relative">
        <div
          className="absolute -right-4 -top-10 z-[10000000] h-8 w-8 cursor-pointer rounded-full bg-transparent transition-all duration-300 ease-in-out hover:opacity-80"
          onClick={handleCloseModal}
        >
          <CircleCloseIcon color="white" size={32} className="cursor-pointer" />
        </div>
        <div className="mb-8 md:mb-10">
          <Image
            className={'mx-auto '}
            alt="Young Washington Logo"
            width={128}
            height={80}
            src={'v1759419818/theatrical/young%20washington/Young-Washington-Logo-Red-Wonder.webp'}
          />
        </div>
        <GTitleLG className="mb-2 hidden text-white md:block">Welcome to the Community</GTitleLG>
        <GTitleMD className="mb-2 text-white md:hidden">Welcome to the Community</GTitleMD>
        <ParagraphMD className="mb-10 hidden !font-roboto text-white md:block">
          Thank you for joining the Young Washington Community. You will receive emails when new updates are available.
          More to come soon.
        </ParagraphMD>
        <ParagraphSM className="mb-8 !font-roboto text-white md:hidden">
          Thank you for joining the Young Washington Community. You will receive emails when new updates are available.
          More to come soon.
        </ParagraphSM>
        <Button
          variant={'oxide-primary'}
          outline={false}
          size={'lg'}
          className={'mx-auto w-fit !border-[#DA2031] !bg-[#DA2031] !font-roboto'}
          onClick={handleCloseModal}
        >
          Close
        </Button>
      </div>
    </Modal>
  )
}
